import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listUsers } from "../actions/userActions";
import Collection from "../components/Collection";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { Link } from "react-router-dom";
import BlueLayout from "../layouts/BlueLayout";
import Curve from "../components/global/Curve";
import { useBreakpoints } from "../hooks/useBreakpoints";
import AppCard from "../components/global/AppCard";

const HomeScreen = () => {
  const { md } = useBreakpoints();
  const dispatch = useDispatch();
  const userList = useSelector((state) => state.userList);
  const { loading, error, users } = userList;
  const cards = [
    {
      colorBg: "bg-red",
      img: require("../assets/images/child.png"),
      subTitle:
        "Specializing in support for cultural organization education programming",
      styleSubTitle: "text-creamy-beige",
      title: "over 20% of BC",
      secondaryTitle: "institutions have joined",
      description:
        "Our team provides curriculum support, training opportunities, and access to classrooms in British Columbia and beyond, Don't try to be an expert in everything, let The VR Voyage Classroom help promote and diversify your outreach so you can focus on what you do best,sharing your institution's story.",
      link: "/for-partners",
      textBtn: "Learn More",
    },
    {
      colorBg: "bg-yellow",
      img: require("../assets/images/computer.png"),
      subTitle: "Make learning fun",
      styleSubTitle: "text-night-blue",
      title: "engagingg teaching ",
      secondaryTitle: "resources direct from the source",
      description:
        "The VR Voyage classroom is creating direct connections between BC teachers and the institutions that hond the keys to the variety of stories that have shaped the province. Working with our curriculum team, each connection is engaging and aligns perfectly with the provincial curriculum.",
      link: "/for-teachers",
      textBtn: "Learn More",
    },
  ];

  useEffect(() => {
    dispatch(listUsers("partner"));
  }, [dispatch]);

  return (
    <BlueLayout>
      <div className="bg-night-blue pb-36 xl:pb-[480px]">
        <div className="flex flex-wrap justify-center relative">
          <div className="lg:pt-16 container xl:sticky xl:z-10">
            <h1 className="text-creamy-beige font-light text-center uppercase md:mt-[50px] xl:text-left xl:w-[450px]">
              The platform that{" "}
              <span className="font-semibold text-canton-jadesheen">
                brings the world to students
              </span>
            </h1>
            <p className="text-creamy-beige leading-5 my-8 text-center lg:my-12 xl:text-left xl:w-[400px]">
              Don't just read about it, experience it! Register today for free
              and start exploring the world with your class right away
            </p>
            <Link
              to="/"
              className="bg-red text-creamy-beige mx-auto xl:mx-0 app-button hover:bg-canton-jadesheen w-fit hover:text-night-blue transition-colors duration-300"
            >
              Explore
              <i
                className="iconify"
                data-icon="iconamoon:arrow-up-2-bold"
                data-rotate="90deg"
              />
            </Link>
          </div>
        </div>
        <picture className="xl:absolute xl:right-0 xl:top-[12px] xl:w-[907px]">
          <img
            src={require("../assets/images/home-hero.gif")}
            alt=""
            className="w-full"
          />
        </picture>
      </div>

      <Curve color="--var-color-vrc-creamy-beige" />

      <div className="-mt-44 lg:-mt-96 container grid lg:grid-cols-2 gap-5">
        {cards.map((e, i) => (
          <AppCard {...e} key={i} />
        ))}
      </div>

      <div className="container grid gap-10 lg:gap-36 xl:gap-x-12 mt-24 lg:mt-36 lg:grid-cols-2">
        <div className="text-center lg:col-span-2 max-w-[769px] mx-auto">
          <h2 className="text-canton-jadesheen mb-8">
            A NEW WORLD IS OPENING UP
          </h2>
          <p>
            Now more than ever, people know the power of virtual reality and
            video conferencing. Find a local experience to take your class on or
            let your students explore beyond their immediate surroundings by
            booking live-streamed field trips to interesting sites around
            British Columbia. Create direct relationships with leading experts
            in a variety of fields and let your class learn directly from the
            source.
          </p>
        </div>

        <div className="mt-14 lg:mt-11 lg:order-3 mb-3 lg:mb-24">
          <p className="font-bold text-lg text-center lg:text-left">
            For Teachers
          </p>
          <h2 className="pt-2 pb-8 text-canton-jadesheen text-center lg:text-left">
            WHAT WILL YOU DISCOVER?
          </h2>
          <p>
            Explore the resources that are available to your class and how to
            bring the curriculum to life. Field trips, presentations, activity
            books, virtual tours, and interactive scavenger hunts are just some
            of the resources waiting for you when you join The VR Voyage
            Classroom community.
          </p>
          <Link
            to="/for-teachers"
            className="app-button w-fit mx-auto text-night-blue hover:text-creamy-beige hover:bg-night-blue transition-colors duration-300 bg-canton-jadesheen mt-8"
          >
            Learn More
          </Link>
        </div>

        <div
          className="bg-center bg-no-repeat bg-contain h-80 lg:h-full -mb-3"
          style={{
            backgroundImage: `url(${require("../assets/images/home-team.png")})`,
          }}
        />
      </div>
      <Curve color="--var-color-vrc-cobalt-blue" />
      <div className="bg-canton-cobalt-blue -mt-1 sticky z-10">
        <div className="container-2 xl:mx-auto lg:grid lg:grid-cols-2">
          <div className="container pt-16 lg:pb-24">
            <span className="text-creamy-beige mb-2 text-center block">
              For Partners
            </span>
            <h2 className="text-yellow text-center block">
              HOW TO SHARE YOUR STORY?
            </h2>
            <p className="text-beige my-8">
              Discover the ways you can promote your education programs through
              listings and our database. Plan, produce, source funding, and
              connect your programming to the BC curriculum with the full
              support of The VR Voyage Classroom’s Curriculum and Partnership
              Coordinators, and production partners.
            </p>
            <button className="app-button w-fit mx-auto lg:mx-0 text-night-blue bg-yellow">
              Learn More
            </button>
          </div>
          <div
            className="bg-no-repeat bg-bottom bg-contain h-[365px] lg:h-full xl:w-[600px]"
            style={{
              backgroundImage: `url(${require(md
                ? "../assets/images/child-diving.png"
                : "../assets/images/child-diving-mobile.png")})`,
            }}
          />
        </div>
      </div>

      <div className="bg-night-blue pt-24 lg:pt-36">
        <h2 className="font-bold mb-8 text-center text-canton-jadesheen ">
          NEW PARTNERING ORGANIZATIONS
        </h2>
        {loading ? (
          <Loader />
        ) : error ? (
          <Message body={error} />
        ) : (
          users && (
            <div className="partners h-fit">
              <Collection
                isInfinite
                speed="120s"
                collectionType="partners"
                items={users}
              />
            </div>
          )
        )}
      </div>
    </BlueLayout>
  );
};

export default HomeScreen;
